module.exports = __webpack_public_path__ + "c31d89455b61cab8740394bb230558c1.svg";